//
export function isDefaultPrevented(event: any): boolean {
  if ('defaultPrevented' in event) {
    return !!event.defaultPrevented
  }
  if ('isDefaultPrevented' in event) {
    return !!event.isDefaultPrevented()
  }
  return false
}
